<!-- delete-church.component.html -->

<div class="addContainer">
    <div class="modalHeader">
        <div class="editRowModal">
            <div class="modalHeader clearfix">
                <div class="modalHeader clearfix">
                    <img src="../../../../../assets/images/emtec.png" alt="avatar" />
                    <div class="modal-about">
                        <div class="font-weight-bold p-t-5 ms-2 me-2 font-17">
                            Delete Outstation
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button mat-icon-button (click)="dialogRef.close()" aria-label="Close dialog">
            <mat-icon>close</mat-icon>
        </button>
    </div>


    <div mat-dialog-content>
        <p style="font-size: 130%;">Are you sure you want to delete <strong>{{outstationProperties.outStationName}}</strong> ?</p>
    </div>
    <div mat-dialog-actions class="editRowModal" style="margin-left: auto;">
        <button mat-raised-button color="warn" class="deleteButton" (click)="onDeleteClick()">Delete</button>
        <button mat-raised-button class="cancelButton" (click)="dialogRef.close()">Cancel</button>
    </div>
</div>